// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a3Timetable_root_BFOkx {
  position: relative;
  width: 100%;
  border-radius: 30px;
  color: var(--hsl-blue);
  --timetable-accent-color: white;
  font-size: 16px;
}

.a3Timetable_tableContentContainer_LPVBa {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
}

.a3Timetable_tableContentContainer_LPVBa > *:first-child {
  height: 731px;
}

.a3Timetable_tableContentContainer_LPVBa > *:not(:first-child) {
  height: 841px;
}

.a3Timetable_a3routeDiagram_WcqpQ {
  padding-left: 5px;
  height: fit-content;
  width: fit-content;
}

.a3Timetable_tableRowsContainer_6ZEOq {
  display: flex;
  /* flex-direction: row; */
  padding-top: 10px;
  max-width: 1171px;
}

.a3Timetable_tableRowsContainer_6ZEOq > *:first-child {
  padding-left: 0px;
}

.a3Timetable_root_BFOkx.a3Timetable_standalone_xOj6E {
  font-size: 22px;
}

.a3Timetable_root_BFOkx.a3Timetable_summer_cS8IB {
  /* background: white;
  --timetable-accent-color: var(--light-background); */
}

.a3Timetable_root_BFOkx.a3Timetable_greyscale_dcMl1 {
  /* background: white;
  color: black;
  --timetable-accent-color: #eaeaea; */
}

.a3Timetable_root_BFOkx.a3Timetable_printable_dOjF_ {
  width: auto;
  border-radius: 0;
}

.a3Timetable_header_PlAeh {
  padding: 0 0 0 0.4em;
}

.a3Timetable_headerTitle_AvixY {
  font-size: 1.75em;
}

.a3Timetable_componentName_Q86Iv {
  padding: 0 0 0 0.205em;
  font-size: 1.875em;
}

.a3Timetable_title_b2T7H {
  font-family: GothamRounded-Medium;
  white-space: nowrap;
  font-size: 0.9em;
}

.a3Timetable_subtitle_azrTE {
  font-family: GothamRounded-Book;
  font-size: 0.9em;
}

.a3Timetable_footnote_GGTSZ {
  padding: 0.125em 0.625em;
  font-family: GothamXNarrow-Book;
  font-size: 0.813em;
}

.a3Timetable_validity_czQYv {
  font-family: GothamXNarrow-Book;
  font-size: 0.75em;
  line-height: 1.1;
  letter-spacing: -0.025em;
  text-align: right;
  margin-left: auto;
  position: absolute;
  margin-top: -5px;
  top: calc(var(--border-radius));
  right: var(--border-radius);
}

.a3Timetable_validity_czQYv .a3Timetable_shortId_k5CGG {
  font-family: GothamRounded-Medium;
  font-size: 1.75em;
}

.a3Timetable_validity_czQYv .a3Timetable_title_b2T7H {
  font-family: GothamRounded-Medium;
}

.a3Timetable_stopZone_Fy5Iy {
  padding-left: 0.5em;
  margin-top: 0.875em;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.a3Timetable_zoneTitle_riOkD {
  font-size: 0.75em;
  line-height: 1.1;
  font-family: GothamRounded-Medium;
  white-space: nowrap;
  margin-right: 0.4em;
}

.a3Timetable_zoneSubtitle_Ml1tp {
  font-size: 0.75em;
  font-family: GothamRounded-Book;
}

.a3Timetable_zone_ZZpVJ {
  position: relative;
  box-sizing: border-box;
  flex: none;
  width: 1.5em;
  height: 1.5em;
  color: white;
  background: var(--hsl-blue);
  border-radius: 50%;
}

.a3Timetable_zoneLetter_h0dQJ {
  font-size: 1.25em;
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  line-height: 1;
  font-family: GothamRounded-Medium;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/a3Timetable/a3Timetable.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;sDACoD;AACtD;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EAEjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B","sourcesContent":[".root {\n  position: relative;\n  width: 100%;\n  border-radius: 30px;\n  color: var(--hsl-blue);\n  --timetable-accent-color: white;\n  font-size: 16px;\n}\n\n.tableContentContainer {\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n}\n\n.tableContentContainer > *:first-child {\n  height: 731px;\n}\n\n.tableContentContainer > *:not(:first-child) {\n  height: 841px;\n}\n\n.a3routeDiagram {\n  padding-left: 5px;\n  height: fit-content;\n  width: fit-content;\n}\n\n.tableRowsContainer {\n  display: flex;\n  /* flex-direction: row; */\n  padding-top: 10px;\n  max-width: 1171px;\n}\n\n.tableRowsContainer > *:first-child {\n  padding-left: 0px;\n}\n\n.root.standalone {\n  font-size: 22px;\n}\n\n.root.summer {\n  /* background: white;\n  --timetable-accent-color: var(--light-background); */\n}\n\n.root.greyscale {\n  /* background: white;\n  color: black;\n  --timetable-accent-color: #eaeaea; */\n}\n\n.root.printable {\n  width: auto;\n  border-radius: 0;\n}\n\n.header {\n  padding: 0 0 0 0.4em;\n}\n\n.headerTitle {\n  font-size: 1.75em;\n}\n\n.componentName {\n  padding: 0 0 0 0.205em;\n  font-size: 1.875em;\n}\n\n.title {\n  font-family: GothamRounded-Medium;\n  white-space: nowrap;\n  font-size: 0.9em;\n}\n\n.subtitle {\n  font-family: GothamRounded-Book;\n  font-size: 0.9em;\n}\n\n.footnote {\n  padding: 0.125em 0.625em;\n  font-family: GothamXNarrow-Book;\n  font-size: 0.813em;\n}\n\n.validity {\n  font-family: GothamXNarrow-Book;\n  font-size: 0.75em;\n  line-height: 1.1;\n  letter-spacing: -0.025em;\n  text-align: right;\n  margin-left: auto;\n  position: absolute;\n  margin-top: -5px;\n  top: calc(var(--border-radius));\n  right: var(--border-radius);\n}\n\n.validity .shortId {\n  font-family: GothamRounded-Medium;\n  font-size: 1.75em;\n}\n\n.validity .title {\n  font-family: GothamRounded-Medium;\n}\n\n.stopZone {\n  padding-left: 0.5em;\n  margin-top: 0.875em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.zoneTitle {\n  font-size: 0.75em;\n  line-height: 1.1;\n  font-family: GothamRounded-Medium;\n  white-space: nowrap;\n  margin-right: 0.4em;\n}\n\n.zoneSubtitle {\n  font-size: 0.75em;\n  composes: zoneTitle;\n  font-family: GothamRounded-Book;\n}\n\n.zone {\n  position: relative;\n  box-sizing: border-box;\n  flex: none;\n  width: 1.5em;\n  height: 1.5em;\n  color: white;\n  background: var(--hsl-blue);\n  border-radius: 50%;\n}\n\n.zoneLetter {\n  font-size: 1.25em;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n  line-height: 1;\n  font-family: GothamRounded-Medium;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `a3Timetable_root_BFOkx`,
	"tableContentContainer": `a3Timetable_tableContentContainer_LPVBa`,
	"a3routeDiagram": `a3Timetable_a3routeDiagram_WcqpQ`,
	"tableRowsContainer": `a3Timetable_tableRowsContainer_6ZEOq`,
	"standalone": `a3Timetable_standalone_xOj6E`,
	"summer": `a3Timetable_summer_cS8IB`,
	"greyscale": `a3Timetable_greyscale_dcMl1`,
	"printable": `a3Timetable_printable_dOjF_`,
	"header": `a3Timetable_header_PlAeh`,
	"headerTitle": `a3Timetable_headerTitle_AvixY`,
	"componentName": `a3Timetable_componentName_Q86Iv`,
	"title": `a3Timetable_title_b2T7H`,
	"subtitle": `a3Timetable_subtitle_azrTE`,
	"footnote": `a3Timetable_footnote_GGTSZ`,
	"validity": `a3Timetable_validity_czQYv`,
	"shortId": `a3Timetable_shortId_k5CGG`,
	"stopZone": `a3Timetable_stopZone_Fy5Iy`,
	"zoneTitle": `a3Timetable_zoneTitle_riOkD`,
	"zoneSubtitle": `a3Timetable_zoneSubtitle_Ml1tp a3Timetable_zoneTitle_riOkD`,
	"zone": `a3Timetable_zone_ZZpVJ`,
	"zoneLetter": `a3Timetable_zoneLetter_h0dQJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
